import React from "react";

interface GamePageToolbarProps {
  onBack: () => void;
  children?: React.ReactNode;
}

const GamePageToolbar: React.FC<GamePageToolbarProps> = ({
  onBack,
  children,
}) => {
  return (
    <div className="mb-3 flex w-full items-start justify-between gap-3">
      <button
        type="button"
        onClick={onBack}
        className="shrink-0 rounded border border-black bg-red-500 px-3 py-2 text-white hover:bg-red-600 lg:px-4"
      >
        Back to Games
      </button>
      {children ? (
        <div className="flex flex-wrap justify-end gap-2">{children}</div>
      ) : null}
    </div>
  );
};

export default GamePageToolbar;
